import axios from 'axios';
import { memo, useState } from 'react';
import appleStoreDownload from './images/apple_store_download.png';
import playStoreDownload from './images/play_store_download.png';
import './index.scss';

export const ExternalFooter = memo(() => {
  return (
    <>
      <div className="footer-bar-en footer">
        <div className="w-container">
          <div className="w-row">
            <FooterRow1 />
            <FooterRow2 />
            <FooterRow3 />
            <FooterRow4 />
          </div>
        </div>
      </div>
      <section className="section-117">
        <div className="w-layout-blockcontainer container-58 w-container">
          <div className="columns-49 w-row">
            <div className="column-116 w-col w-col-6">
              <h4 className="heading-221">
                Official Market Data Provided By <a href="https://www.dse.com.bd/">Dhaka Stock Exchange </a>
              </h4>
            </div>
            <div className="column-120 w-col w-col-6">
              <h4 className="heading-219">
                Designed And Developed By <a href="https://www.biniyog.com.bd">biniyog.com.bd</a>
              </h4>
            </div>
          </div>
        </div>
      </section>
      <div className="footer-bar-en footer footer-bar">
        <div className="w-container">
          <div className="text-block">{`Copyright ${new Date().getFullYear()} Biniyog. All Rights Reserved.`}</div>
        </div>
      </div>
    </>
  );
});

const FooterRow1 = memo(() => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [isError, setIsError] = useState<boolean>(false);

  const handleSubmit = (e: any) => {
    setIsSubmitting(true);
    e.preventDefault();
    const { email } = e.target.elements;
    axios
      .post(`${process.env.NX_CORE_BASE_URL}/customers/subscribe-newsletter`, { email: email?.value })
      .then((res) => {
        setIsSuccess(true);
      })
      .catch((e) => {
        setIsError(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  return (
    <div className="w-col w-col-6">
      <a href="https://biniyog.com.bd" className="w-inline-block" aria-label="biniyog-link">
        <img
          src="https://cdn.prod.website-files.com/625bcc250b9c6b71921a004d/62ad9c09371b05d3fdc0f99a_Logo%20Biniyog.svg"
          loading="lazy"
          alt=""
          width="212px"
          height="67px"
        />
        {/* <img style={{ width: '204px', height: '65px' }} src="/assets/logo/logo_biniyog.png" loading="lazy" alt="" /> */}
      </a>
      <div className="footer-slogan">Sign up for our newsletter</div>
      <div className="newsletter-form w-form">
        <form
          id="wf-form-newsletter"
          name="wf-form-newsletter"
          data-name="Newsletter"
          method="get"
          className="w-clearfix"
          data-wf-page-id="628b14aa5549af1a67a47da2"
          data-wf-element-id="01e074c6-22fd-c9dc-e9ba-8871f3caaad4"
          aria-label="Newsletter"
          onSubmit={handleSubmit}
          style={{ display: isError || isSuccess ? 'none' : 'block' }}
        >
          <input
            className="newsletter-field w-input"
            maxLength={256}
            name="email"
            data-name="Email 2"
            placeholder="Email Address"
            type="email"
            id="email"
            required={true}
          />
          <input
            type="submit"
            data-wait="Wait..."
            className="newsletter-button w-button"
            value={isSubmitting ? 'Wait...' : 'Subscribe'}
          />
        </form>
        <div
          style={{ display: isSuccess ? 'block' : 'none' }}
          className="success-message w-form-done"
          tabIndex={-1}
          role="region"
          aria-label="Newsletter success"
        >
          <p>Thank you! You’ll receive an email shortly.</p>
        </div>
        <div
          style={{ display: isError ? 'block' : 'none' }}
          className="w-form-fail"
          tabIndex={-1}
          role="region"
          aria-label="Newsletter failure"
        >
          <p>Oops! Something went wrong while submitting the form :(</p>
        </div>
      </div>
      <h4 className="heading-75">Follow Us on Social</h4>

      <div className="social-container">
        <a href="https://www.facebook.com/biniyog.com.bd" target="_blank" className="" aria-label="biniyog-facebook">
          <img
            src="https://cdn.prod.website-files.com/625bcc250b9c6b71921a004d/62bdf68fb7f69d5ea3036fdf_1.png"
            loading="lazy"
            width="40px"
            height="40px"
            alt=""
          />
        </a>

        <a
          href="https://www.linkedin.com/company/biniyog-bd"
          target="_blank"
          className="w-inline-block"
          aria-label="biniyog-linkedin"
        >
          <img
            src="https://cdn.prod.website-files.com/625bcc250b9c6b71921a004d/64cf00aa0aef8ef8c778a9cd_702300.png"
            loading="lazy"
            width="40px"
            height="40px"
            sizes="41px"
            alt=""
            srcSet="https://assets-global.website-files.com/625bcc250b9c6b71921a004d/64cf00aa0aef8ef8c778a9cd_702300-p-500.png 500w, https://assets-global.website-files.com/625bcc250b9c6b71921a004d/64cf00aa0aef8ef8c778a9cd_702300.png 512w"
          />
        </a>

        <a
          href="https://www.youtube.com/@biniyog-bd"
          target="_blank"
          className="w-inline-block"
          aria-label="biniyog-youtube"
        >
          <img
            src="https://cdn.prod.website-files.com/625bcc250b9c6b71921a004d/62bdf6c9b7f69d80ba037374_3.png"
            loading="lazy"
            width="40px"
            height="40px"
            alt=""
          />
        </a>
      </div>

      <div className="download-container">
        <h4 className="heading-75">Download The App</h4>
        <div className="download-button-container">
          <a
            href="https://mobile.biniyog.com.bd"
            target="_blank"
            className="w-inline-block"
            aria-label="biniyog-youtube"
          >
            <img src={appleStoreDownload} width={128} height={40} loading="lazy" alt="" />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=bd.com.biniyog.mobile"
            target="_blank"
            className="w-inline-block"
            aria-label="biniyog-youtube"
          >
            <img src={playStoreDownload} width={128} height={40} loading="lazy" alt="" />
          </a>
        </div>
      </div>
    </div>
  );
});

export const FooterRow2 = memo(() => (
  <div className="w-col w-col-2">
    <h4 className="footer-title">important links</h4>
    <a href="https://www.biniyog.com.bd/">Home</a>
    <a href="https://www.biniyog.com.bd/about">
      <br />
      About
    </a>
    <a href="https://www.biniyog.com.bd/learn">
      <br />
      Learn
    </a>
    <a href="https://www.biniyog.com.bd/feature" className="page-link in-footer">
      Features
    </a>
    <a href="https://www.biniyog.com.bd/contact">Contact</a>
    <a href="https://www.biniyog.com.bd/campaign">
      <br />
      Offers
    </a>
    <a href="https://www.biniyog.com.bd/downloads">
      <br />
      Downloads
    </a>
  </div>
));

export const FooterRow3 = memo(() => (
  <div className="w-col w-col-2">
    <h4 className="footer-title">services</h4>
    <a href="https://www.biniyog.com.bd/share-market">Share Market</a>
    <div>
      <a href="https://biniyog.com.bd/latest-share-price">Market Price</a>
    </div>
    <div>
      <a href="https://biniyog.com.bd/dse-news">Market News</a>
    </div>
    <a href="https://biniyog.com.bd/sharemarket/main">Market Data</a>
    <br />
    <a href="https://biniyog.com.bd/sharemarket/chart">Technical Analysis</a>
    <div>
      <a href="https://www.biniyog.com.bd/ipo">IPO</a>
    </div>
    <a href="https://www.biniyog.com.bd/bank">Bank</a>
    <a href="https://www.biniyog.com.bd/manual-portfolio">
      <br />
      Manual Portfolio
    </a>
    <a href="https://www.biniyog.com.bd/sanchayapatra">
      <br />
      Sanchayapatra
    </a>
    <a href="https://www.biniyog.com.bd/fund-transfer">
      <br />
      Fund Transfer
    </a>
    <a href="https://www.biniyog.com.bd/paper-trading">
      <br />
      Paper Trading
    </a>

    <a href="https://www.biniyog.com.bd/tax">
      <br />
      Tax
    </a>
  </div>
));

export const FooterRow4 = memo(() => (
  <div className="w-col w-col-2">
    <h4 className="footer-title">Legal</h4>
    <a href="https://www.biniyog.com.bd/privacy" className="page-link in-footer">
      Privacy Policy
    </a>
    <a href="https://www.biniyog.com.bd/terms-conditions" className="page-link in-footer">
      Terms &amp; Conditions
    </a>
    <div>
      <a href="https://www.biniyog.com.bd/refund-policy" className="w-inline-block">
        <div className="text-block-37">Refund Policy</div>
      </a>
    </div>
  </div>
));
